import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const LeadInfoPanel = ({ title, icon, children, collapsible = false }) => {
  const [isExpanded, setIsExpanded] = React.useState(true);

  return (
    <div className="bg-card rounded-lg border border-border elevation-1 overflow-hidden">
      <div 
        className={`p-6 border-b border-border bg-muted/30 ${collapsible ? 'cursor-pointer hover:bg-muted/40 transition-colors duration-200' : ''}`}
        onClick={() => collapsible && setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-semibold text-foreground flex items-center gap-2">
            <Icon name={icon} size={20} />
            {title}
          </h2>
          {collapsible && (
            <Icon 
              name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
              size={20} 
              className="text-muted-foreground"
            />
          )}
        </div>
      </div>
      {(!collapsible || isExpanded) && (
        <div className="p-6">
          {children}
        </div>
      )}
    </div>
  );
};

export default LeadInfoPanel;